import { autoinject } from "aurelia-framework";

import { FetchClient } from "../common/fetch-client";
import type {
    ICalendarExportRequest,
    IExortHuvListPayload,
    IFrequencyWatchRequest,
    IFrequencyWatchResponse,
    IFrequencyWatchWeeklyRequest,
    IHuvSfvStatusListPayload
} from "../resources-vue/vue-interfaces/i-reports";

@autoinject()
export class ReportService {
    private _httpClient: FetchClient;
    private _baseUrl: string = "/api/v1/reports";

    public constructor(httpClient: FetchClient) {
        this._httpClient = httpClient;
    }

    public async getFrequencyWatch(payload: IFrequencyWatchRequest) {
        return await this._httpClient
            .build(`${this._baseUrl}/schedule/frequencywatch`)
            .useMethod("POST")
            .useBody(payload)
            .fetch<IFrequencyWatchResponse[]>();
    }

    public async getFrequencyWatchWeekly(payload: IFrequencyWatchWeeklyRequest) {
        return await this._httpClient
            .build(`${this._baseUrl}/schedule/frequencywatch/weekly`)
            .useMethod("POST")
            .useBody(payload)
            .fetch();
    }

    public async getHuvSfvStatusList(payload: IHuvSfvStatusListPayload) {
        return await this._httpClient
            .build(`${this._baseUrl}/schedule/huv-and-sfv-status`)
            .useMethod("POST")
            .useBody(payload)
            .fetch();
    }

    public async exportHuvList(payload: IExortHuvListPayload) {
        return await this._httpClient
            .build(`${this._baseUrl}/huv-and-sfv-status/excel`)
            .useMethod("POST")
            .useBody(payload)
            .fetchBlob();
    }

    public async patientCalendarExport(options: ICalendarExportRequest) {
        return await this._httpClient
            .build(`${this._baseUrl}/patient-calendar/excel`)
            .useMethod("POST")
            .useBody(options)
            .fetchBlob();
    }
    public async patientCalendarPdfExport(options: ICalendarExportRequest) {
        return await this._httpClient
            .build(`${this._baseUrl}/patient-calendar/pdf`)
            .useMethod("POST")
            .useBody(options)
            .fetchBlob();
    }
}
